module.exports = "<div class=\"form-confirmation\">\n    <div class=\"form-confirmation__header\">\n        <p>You submitted</p>\n        <p class=\"h2\" style=\"padding-top:20px;\" ng-repeat=\"item in submissionList\">{{item}}</p>\n    </div>\n    <div class=\"form-confirmation__message\">\n        <p>Your submissions have been received by MTC and are currently in review. We will contact you should any questions arise or any further information be required.</p>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/components/directives/submissionsectionconfirmation/submissionsectionconfirmation.html
// module id = 86
// module chunks = 0